import colorsets from './colorsets';

/**
 * DataHelper
 */
export default class DataHelper {

    constructor(options, cb) {

        this.cb = cb;
        this.map = options.url.split('/').pop();
        this.url = options.url;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.colorset = options.color;
        this.random = options.random;
        this.video = true;

        this.key = 0; //current key index
        this.lastKey = -1; //last key index
        this.speed = 1; //playback speed
        this.isPlaying = false;
        this.playStart = 0; //start of playback
        this.frame = null; //animation frame

        this.positions = {};
        this.colors = {};
        
        if(!this.url) throw new Error('DataHelper needs a file url');
        
        this.drawn = false;

        this.loadMedia();
    }

    play = () => {

        if(!this.data) throw new Error('Data not ready to play');

        this.isPlaying = true;
        this.playStart = performance.now();
        window.cancelAnimationFrame(this.frame);

        const { timestep } = this.data;
        const duration = timestep * this.data.keys.length;

        const loop = () => {

            const now = performance.now();
            let videotime = ((now - this.playStart)/1000);
            if(this.data.rewind) {
                videotime = videotime % (duration*2);
                if(videotime > duration) {
                    videotime = duration - (videotime%duration);
                }
            } else {
                videotime = videotime % duration;
            }

            this.key = Math.floor((videotime/timestep));
            //@TODO why do I have to clamp?
            this.key = Math.min(this.key, this.data.keys.length-1);
            this.key = Math.max(this.key, 0);
            this.frame = window.requestAnimationFrame(loop);
        }
        loop();
    }

    pause = () => {
        this.isPlaying = false;
        this.key = 0;
        window.cancelAnimationFrame(this.frame);
    }

    loadMedia = () => {

        new Promise((resolve, reject) => {

            window.fetch(this.url)
                .then(function(res) {
                    if (!res.ok) reject('Error loading Data', this.url, res);
                    return res;
                })
                .then(res => res.json())
                .then(res => {
                    this.data = res;
                    resolve();
                })
        }).then(() => {
            if(this.cb) this.cb();
        });
    }

    update = (options, cb) => {
        this.colorset = options.color;
        this.width = options.width;
        this.height = options.height;
        this.depth = options.depth;
        this.random = options.random;
        
        if(cb) cb();
    }

    readCanvas = () => {

        const { data, width, height, depth, colorset, random } = this;
        const positions = [];
        const colors = [];

        if(this.key !== this.lastKey) {
            let i=0;
            for(let y=0; y<480;y+=data.step) {
                for(let x=0; x<640;x+=data.step) {

                    const v = data.keys[this.key][i++];
                    if(v < 8) continue;

                    let _x = x/640 * 2 - 1;
                    let _y = y/480 * -2 + 1;
                    let _z = v/255;                

                    const rgb = colorsets[colorset](_x, _y, v, v, v, v);

                    _x *= width;
                    _y *= height;
                    _z *= depth;

                    if(random) {
                        _x += (Math.random()-0.5) * 2 * random;
                        _y += (Math.random()-0.5) * 2 * random;
                        _z += (Math.random()-0.5) * 2 * random;
                    }
                    
                    positions.push( _x, _y, _z );
                    colors.push( ... rgb );
                }
            }

            this.positions = positions;
            this.colors = colors;
            this.lastKey = this.key;
        }
        
        return {
            positions: this.positions,
            colors: this.colors
        };
    }
}